export default __webpack_public_path__ + "static/10-90e40144b7579ae8862ff17c3b508707.jpg";